export default "__VITE_ASSET__he9s3RhD__"